<template>
  <div class="row mx-0 px-3 px-md-0 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="graduated_year">最終学歴年月/区分</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="row px-0">
        <div class="col-4 col-md-3 pe-0">
          <Field
            v-slot="{ field, errors }"
            v-model="resumeEducation.graduated_year"
            name="candidate_resume.graduated_year"
          >
            <select
              id="graduated_year"
              class="form-select select-input-primary size-14 me-1 p-0d8"
              placeholder="年"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
            >
              <option value="" disabled selected>年</option>
              <option
                v-for="e in getListNumber(1900, new Date().getFullYear())"
                :key="e"
                :value="e"
              >
                {{ e }}
              </option>
            </select>
            <ErrorMessage name="candidate_resume.graduated_year" class="invalid-feedback" />
          </Field>
        </div>
        <div class="col-4 col-md-3 pe-0">
          <Field
            v-slot="{ field, errors }"
            v-model="resumeEducation.graduated_month"
            name="candidate_resume.graduated_month"
          >
            <select
              id="graduated_month"
              class="form-select select-input-primary size-14 me-1 p-0d8"
              placeholder="月"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
            >
              <option value="" disabled selected>月</option>
              <option v-for="e in getListNumber(1, 12)" :key="e" :value="e">{{ e }}</option>
            </select>
            <ErrorMessage name="candidate_resume.graduated_month" class="invalid-feedback" />
          </Field>
        </div>
        <div class="col-4 col-md-6 pe-0">
          <Field
            v-slot="{ field, errors }"
            v-model="resumeEducation.graduation_classification_id"
            name="candidate_resume.graduation_classification_id"
          >
            <select
              id="graduation_classification"
              class="form-select select-input-primary size-14 me-1 p-0d8"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
            >
              <option value="" disabled selected>選択してください</option>
              <option
                v-for="graduation_classification in graduation_classifications"
                :key="graduation_classification.id"
                :value="graduation_classification.id"
              >
                {{ graduation_classification.name }}
              </option>
            </select>
            <ErrorMessage
              name="candidate_resume.graduation_classification_id"
              class="invalid-feedback"
            />
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { Field, ErrorMessage } from 'vee-validate';
import { useResumeEducationStore } from '@/stores/resume-candidate/ResumeEducation.store';
import getListNumber from '@/utils/getListNumber';
import { GraduationClassificationType } from '@/types/models/GraduationClassification';
import { getGraduationClassifications } from '@/apis/candidate';

const graduation_classifications = ref<GraduationClassificationType[]>([]);
const resumeEducation = useResumeEducationStore();

onMounted(() => {
  loadGraduationClassifications();
});

const loadGraduationClassifications = async (): Promise<void> => {
  const response = await getGraduationClassifications();
  if (response.status == 200) {
    graduation_classifications.value = response.data;
  }
};
</script>
